module.exports = __webpack_public_path__ + "img/seher_px1.88fd0f93.png";